export const ITEM_ICONS = {
    // Pistols
    glock: 'glock.3278cf394b5f33567080dde9fd49d936.svg',
    hkp2000: 'hkp2000.741abf815199ee65cb3b7e0f5dc362a2.svg',
    usp_silencer: 'usp_silencer.e9a11322157d830fed90b15bd6c2022e.svg',
    elite: 'elite.6addf9dc01ebdcbd95237702244bd379.svg',
    p250: 'p250.63c70df280d74f69d0da4148d1672967.svg',
    fiveseven: 'fiveseven.dbdc1aa64c4f54084564933231fc2fdf.svg',
    tec9: 'tec9.ed6df5c630ec5e68ef7d4c477405d147.svg',
    cz75a: 'cz75a.d4e4a0c0c7dac2323d8b535f8c58edef.svg',
    deagle: 'deagle.22985d6c2da201cbfcf7f7ed9fff4ff5.svg',
    revolver: 'revolver.917053b22c2456c7cb6e602df2cec655.svg',

    // SMGs
    mac10: 'mac10.07ca941170b0fd9fb87fb84c8f1c3211.svg',
    mp9: 'mp9.74332ef16bc9c06dc9b15a41497714a9.svg',
    mp7: 'mp7.25816d09a193a843f52068ea4cd2b2ef.svg',
    mp5sd: 'mp5sd.5bfc047eaf4f4c19bf5cf514c81bfc3b.svg',
    ump45: 'ump45.e5b85164744f46b65df98570cfb1af61.svg',
    p90: 'p90.bcb741d414085a784770a869617464fd.svg',
    bizon: 'bizon.753c1cb4c3976fd656df150ce67e88bc.svg',

    // Rifles
    galilar: 'galilar.2c31b1a6034df917d7bdfbab9c14b2f3.svg',
    famas: 'famas.cd63cb950f830be5d5ec4ca256a18ec5.svg',
    ak47: 'ak47.93f31e533b899a5a939a540e8af16306.svg',
    m4a1: 'm4a1.ac763b6ec3b3317ac08c2a3a9adcfa19.svg',
    m4a1_silencer: 'm4a1_silencer.516451b5f4f32607b029c558e6aef5a6.svg',
    ssg08: 'ssg08.311886fc27d78a59e15a80f0de5f36ff.svg',
    sg556: 'sg556.4108ac63e564bbc9b7889baf2f9e0346.svg',
    aug: 'aug.b181c82dd0a2e370a922d810caa8a0e8.svg',
    awp: 'awp.50ed4e16314825b10378975cb5426e8d.svg',
    g3sg1: 'g3sg1.d4e688d6aa676c78a1bc47ecd1b4d713.svg',
    scar20: 'scar20.02dcae6ac466e461a427506898d1db6e.svg',

    // Heavy
    nova: 'nova.5fa8ce14b2d1a545eb68cc360f192bc1.svg',
    xm1014: 'xm1014.7fad9b97a348415fc87e25cab9cb18d9.svg',
    sawedoff: 'sawedoff.e7fecc3da585c848ec3d0a6e5a410f11.svg',
    mag7: 'mag7.4950a3368b7139f89ccae0d8dc997f69.svg',
    m249: 'm249.ed637145c13c756239332de16f9236ee.svg',
    negev: 'negev.6f91b15a40b9d3f9e92b2b8684d9c4c8.svg',

    // Grenades
    flashbang: 'flashbang.b5738807796803cf1b590c583fb5bd76.svg',
    smokegrenade: 'smokegrenade.9ec30d8af0cfa975a8c21bce74e942ba.svg',
    hegrenade: 'hegrenade.44d3d68d13564826d8b53165b5b5c539.svg',
    molotov: 'molotov.5ec3cc4f256788e088da9eb32a3c4b8e.svg',
    incgrenade: 'incgrenade.53922ead15b61b478e5631f0901bf1b0.svg',
    decoy: 'decoy.667ae9b6d2f638893bb56bc8884e7476.svg',

    vest: 'icon_armor_half_default.7e15634a3ff33953424c538ab4560f75.svg',
    vesthelm: 'icon_armor_helmet_default.4e9e3c0109d28a4b5fd97704f29462d1.svg',
    defuser: 'icon_defuse_default.a3360d7628b67da82eb454caa50bcd4e.svg',
    taser: 'taser.9bc054356d14bf024b612d84b07d3200.svg',

    // Extra
    knife: 'knife.f3d5edc6a11a9a754f2b703d83b7212f.svg',
    c4: 'c4.d6f8ea84e54d2336a3324800ae18ab77.svg',
    microphone: 'icon_microphone.cc0d38d7ea30089ac4bff85f237d2e3d.svg',
};

export const getItemIcon = (itemId) => {
    if (!itemId) return null;
    const filename = ITEM_ICONS[itemId];
    if (!filename) return null;
    return `/hud/${filename}`;
};
